import { render, staticRenderFns } from "./IncidentTable.vue?vue&type=template&id=8667f2a6&scoped=true"
import script from "./IncidentTable.vue?vue&type=script&lang=js"
export * from "./IncidentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8667f2a6",
  null
  
)

export default component.exports